export default __webpack_public_path__ + "static/media/logo_SW_Prayer.9625a6f4.svg";